import React from 'react';
import { Box, Flex, Text, Tooltip } from '@chakra-ui/react';
import { StatusColors, StatusType } from '../../constants/statusColors';
import { useTranslation } from 'react-i18next';

interface StatusBoxProps {
  status: StatusType;
  label?: string;
  showText?: boolean;
  textColor?: string;
}

const StatusBox: React.FC<StatusBoxProps> = ({ status, label, showText = false, textColor }) => {
  const { t } = useTranslation();
  const displayLabel = label || t(status);

  const statusCircle = (
    <Box
      bg={StatusColors[status]}
      borderRadius="50%"
      width="25px"
      height="25px"
      mr={showText ? "10px" : "0"}
      className={`status-circle status-${status.toLowerCase().replace(/\s+/g, '-')}`}
      data-status={status}
      style={{
        WebkitPrintColorAdjust: 'exact',
        printColorAdjust: 'exact',
        colorAdjust: 'exact'
      }}
    />
  );

  if (showText) {
    return (
      <Flex alignItems="center">
        {statusCircle}
        <Text fontSize="18px" color={textColor}>
          {displayLabel}
        </Text>
      </Flex>
    );
  }

  return (
    <Tooltip
      label={displayLabel}
      bg={StatusColors[status]}
      color="black"
      placement="bottom-start"
      borderRadius="20px"
      px="10px"
      h="25px"
    >
      {statusCircle}
    </Tooltip>
  );
};

export default StatusBox;
